import { render, staticRenderFns } from "./MessageEdit.vue?vue&type=template&id=7b92c1f4&scoped=true"
import script from "./MessageEdit.vue?vue&type=script&lang=js"
export * from "./MessageEdit.vue?vue&type=script&lang=js"
import style0 from "./MessageEdit.vue?vue&type=style&index=0&id=7b92c1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b92c1f4",
  null
  
)

export default component.exports